import { Button } from "@/atoms-react/button/Button.react";
import { Modal } from "@/atoms-react/modal/index.react";
import { Base, CardTitle } from "@/atoms-react/text/Text.react";
import { AnimatedEnvelopePass } from "@/components/animations/envelope-olkypass/index.react";
import { useKYCContext } from "@/features/auth/hooks/use-kyc-context";
import { KYCStatusType } from "@/features/kyc/types";
import { Themes } from "@/types/theme";
import type React from "react";
import { useTranslation } from "react-i18next";

type ModalOlkyPassProps = {
  isOpen: boolean;
  imageUrl: string;
  title: string;
  description: string;
  onClose: () => void;
  intermediate: boolean;
} & React.ComponentPropsWithoutRef<"div">;

export const ModalOlkyPass = ({
  isOpen,
  title,
  description,
  imageUrl,
  onClose,
  intermediate
}: ModalOlkyPassProps) => {
  const { t } = useTranslation(["pass"]);
  const { status } = useKYCContext();
  return (
    <Modal open={isOpen} closable onClose={onClose} className="w-full max-w-lg sm:w-[550px]">
      <div className={`flex flex-col ${intermediate ? "h-[480px]" : "h-[550px]"} sm:h-[550px]`}>
        <div className="mb-6 flex w-full items-center justify-center overflow-hidden rounded-sm bg-slate-50 p-6">
          {status === KYCStatusType.DECLARATIVE && <AnimatedEnvelopePass srcImg={imageUrl} />}
          {status === KYCStatusType.VERIFIED && <AnimatedEnvelopePass srcImg={imageUrl} />}
          {status === KYCStatusType.AUTHENTICATED && <AnimatedEnvelopePass srcImg={imageUrl} />}
          {status === KYCStatusType.AUTHENTICATED_BRONZE && (
            <AnimatedEnvelopePass srcImg={imageUrl} />
          )}
          {status === KYCStatusType.AUTHENTICATED_GOLD && (
            <AnimatedEnvelopePass srcImg={imageUrl} />
          )}
          {status === KYCStatusType.AUTHENTICATED_SILVER && (
            <AnimatedEnvelopePass srcImg={imageUrl} />
          )}
        </div>
        <CardTitle className="mb-4 px-2 text-center">
          {" "}
          <span>
            {t("olkypass.mainPage.olkypass.modalOlkyPass.title_first_part")}{" "}
            <span className="text-primary">
              {t("olkypass.mainPage.olkypass.modalOlkyPass.title_second_part")}
            </span>
            <br></br>
            {title}
          </span>{" "}
        </CardTitle>
        <Base className="mb-10 text-center text-slate-400 text-sm leading-relaxed dark:text-slate-400">
          {description}
        </Base>

        <Button
          className="px-2 py-4 text-primary text-sm"
          onClick={() => onClose()}
          theme={Themes.white}
        >
          {t("olkypass.mainPage.olkypass.modalOlkyPass.button_modal_passport_close")}
        </Button>
      </div>
    </Modal>
  );
};
